<template>
  <div class="scan-code-bg"></div>
</template>

<script>
import { postlogin4AApi, getLoginUser, getUserProjects } from "@/api/api";

export default {
  name: "passageway",
  components: {},
  data() {
    return {};
  },
  methods: {
    init() {
      const {
        indexProjectString,
        layout,
        stype,
        tkone,
        nowProjectId,
        scenarioGroupId,
      } = this.$route.query;

      if (stype) {
        window.sessionStorage.setItem("token", tkone);
        window.sessionStorage.setItem("refreshToken", tkone);
        window.sessionStorage.setItem("nowProjectId", nowProjectId);
        const params = {
          name: "Index",
          params: {
            stype,
            layout,
            scenarioGroupId: scenarioGroupId || 0,
          },
        };

        if (indexProjectString) {
          params.params.indexProjectString = indexProjectString;
        }
        window.sessionStorage.setItem("IsNew", "new");
        this.$router.push(params);
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style>
.scan-code-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #000;
}
</style>
